// src/app/services/currency-format.service.ts
import { Injectable, signal } from '@angular/core';
import { HsDeal } from '@/models/hs-contact';

@Injectable({
  providedIn: 'root'
})
export class DealsService {
deals = signal<HsDeal[]>([]);

setDeals(deals: HsDeal[]) {
  this.deals.set(deals);
}

getDeals() {
  return this.deals();
}
}